import {RoleEnum} from 'src/api/ProactApiClient';
import {RoleGuard} from './RoleGuard';

export interface AdminRoleGuardProps {
  showDeniedMessage?: boolean;
  children?: React.ReactNode;
}

export const AdminRoleGuard: React.FC<AdminRoleGuardProps> = ({
  showDeniedMessage = false,
  children,
}) => {
  return (
    <RoleGuard
      roles={[RoleEnum.InstanceAdmin]}
      showDeniedMessage={showDeniedMessage}>
      {children}
    </RoleGuard>
  );
};
